import { useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ID_KEY = "gm_visitor_id";
const PING_KEY = "gm_visit_ping";

const visitorId = () => {
  let id = localStorage.getItem(ID_KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, "");
    localStorage.setItem(ID_KEY, id);
  }
  return id;
};

// Counts one anonymous visit per browser per day; re-pings once after sign-in to link the visitor.
export const VisitTracker = () => {
  const { user, loading } = useAuth();
  useEffect(() => {
    if (loading) return;
    try {
      const stamp = `${new Date().toDateString()}|${user?.user_id || ""}`;
      if (localStorage.getItem(PING_KEY) === stamp) return;
      api.post("/analytics/visit", { visitor_id: visitorId() })
        .then(() => localStorage.setItem(PING_KEY, stamp))
        .catch(() => {});
    } catch {
      /* storage blocked: skip counting */
    }
  }, [user?.user_id, loading]);
  return null;
};
